import { createReducer } from 'reduxsauce';
import { cloneDeep, isEqual, findIndex, filter } from 'lodash';

import { CHECKLIST_TYPES } from '../../constants/app.constants';
import { ChecklistTypes } from '../actions/checklist.actions';

const initialState = {
  status: [],
  newHireChecklist: [],
  terminateChecklist: [],
  startShiftChecklist: [],
  endShiftChecklist: [],
  activityTrackerChecklist: [],
  motionTrackerChecklist: [],
  newHireChecklistByCategory: [],
  terminateChecklistByCategory: [],
  startShiftChecklistByCategory: [],
  endShiftChecklistByCategory: [],
  activityTrackerChecklistByCategory: [],
  motionTrackerChecklistByCategory: [],
  successSubmitUserNTChecklist: null,
  userNTChecklist: null,
  successSubmitStartShiftChecklist: null,
  successSubmitEndShiftChecklist: null,
  userStartShiftChecklist: {},
  userEndShiftChecklist: {},
  updatedCheckist: [],
};

const getChecklistRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-checklist');

  return { ...state, status };
};
const getChecklistSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-checklist', a));

  if (action.category === CHECKLIST_TYPES.new_hire) {
    return { ...state, newHireChecklist: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.terminate) {
    return { ...state, terminateChecklist: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.start_shift) {
    return { ...state, startShiftChecklist: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.end_shift) {
    return { ...state, endShiftChecklist: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.activity_tracker) {
    return { ...state, activityTrackerChecklist: action.response, status };
  }
  return { ...state, motionTrackerChecklist: action.response, status };
};
const getChecklistFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-checklist', a));

  return { ...state, status };
};

const getChecklistByCategoryRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-checklist');

  return { ...state, status };
};
const getChecklistByCategorySuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-checklist', a));

  if (action.category === CHECKLIST_TYPES.new_hire) {
    return { ...state, newHireChecklistByCategory: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.terminate) {
    return { ...state, terminateChecklistByCategory: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.start_shift) {
    return { ...state, startShiftChecklistByCategory: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.end_shift) {
    return { ...state, endShiftChecklistByCategory: action.response, status };
  }
  if (action.category === CHECKLIST_TYPES.activity_tracker) {
    return {
      ...state,
      activityTrackerChecklistByCategory: action.response,
      status,
    };
  }
  return {
    ...state,
    motionTrackerChecklistByCategory: action.response,
    status,
  };
};
const getChecklistByCategoryFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-checklist', a));

  return { ...state, status };
};

const createChecklistItemRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-create-checklist-item');

  return { ...state, status };
};
const createChecklistItemSuccess = (state, action) => {
  const item = action.response.checklist;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-checklist-item', a));

  if (item.category === CHECKLIST_TYPES.new_hire) {
    const newHireChecklist = cloneDeep(state.newHireChecklist);
    newHireChecklist.push(item);

    return { ...state, newHireChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.terminate) {
    const terminateChecklist = cloneDeep(state.terminateChecklist);
    terminateChecklist.push(item);

    return { ...state, terminateChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.start_shift) {
    const startShiftChecklist = cloneDeep(state.startShiftChecklist);
    startShiftChecklist.push(item);

    return { ...state, startShiftChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.end_shift) {
    const endShiftChecklist = cloneDeep(state.endShiftChecklist);
    endShiftChecklist.push(item);

    return { ...state, endShiftChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.activity_tracker) {
    const activityTrackerChecklist = cloneDeep(state.activityTrackerChecklist);
    activityTrackerChecklist.push(item);

    return { ...state, activityTrackerChecklist, status };
  }
  const motionTrackerChecklist = cloneDeep(state.motionTrackerChecklist);
  motionTrackerChecklist.push(item);

  return { ...state, motionTrackerChecklist, status };
};
const createChecklistItemFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-checklist-item', a));

  return { ...state, status };
};

const createChecklistItemsMultipleSuccess = (state, action) => {
  const checklist = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-checklist-item', a));

  return { ...state, updatedCheckist: checklist, status };
};

const createChecklistItemsMultipleRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-create-checklist-item');

  return { ...state, status };
};

const createChecklistItemsMultipleFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-create-checklist-item', a));

  return { ...state, status };
};

const editChecklistItemRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-edit-checklist-item-${action.checklistItemId}`);

  return { ...state, status };
};
const editChecklistItemSuccess = (state, action) => {
  const item = action.response.checklist;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-edit-checklist-item-${item.id}`, a));

  if (item.category === CHECKLIST_TYPES.new_hire) {
    const newHireChecklist = cloneDeep(state.newHireChecklist);
    const idx = findIndex(newHireChecklist, (e) => e.id === item.id);
    newHireChecklist[idx] = item;

    return { ...state, newHireChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.terminate) {
    const terminateChecklist = cloneDeep(state.terminateChecklist);
    const idx = findIndex(terminateChecklist, (e) => e.id === item.id);
    terminateChecklist[idx] = item;

    return { ...state, terminateChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.start_shift) {
    const startShiftChecklist = cloneDeep(state.startShiftChecklist);
    const idx = findIndex(startShiftChecklist, (e) => e.id === item.id);
    startShiftChecklist[idx] = item;

    return { ...state, startShiftChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.end_shift) {
    const endShiftChecklist = cloneDeep(state.endShiftChecklist);
    const idx = findIndex(endShiftChecklist, (e) => e.id === item.id);
    endShiftChecklist[idx] = item;

    return { ...state, endShiftChecklist, status };
  }
  if (item.category === CHECKLIST_TYPES.activity_tracker) {
    const activityTrackerChecklist = cloneDeep(state.activityTrackerChecklist);
    const idx = findIndex(activityTrackerChecklist, (e) => e.id === item.id);
    activityTrackerChecklist[idx] = item;

    return { ...state, activityTrackerChecklist, status };
  }
  const motionTrackerChecklist = cloneDeep(state.motionTrackerChecklist);
  const idx = findIndex(motionTrackerChecklist, (e) => e.id === item.id);
  motionTrackerChecklist[idx] = item;

  return { ...state, motionTrackerChecklist, status };
};
const editChecklistItemFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-edit-checklist-item-${action.checklistItemId}`, a));

  return { ...state, status };
};

const deleteChecklistItemRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-delete-checklist-item-${action.checklistItemId}`);

  return {
    ...state,
    status,
  };
};
const deleteChecklistItemSuccess = (state, action) => {
  const { checklistItemId, category } = action;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-checklist-item-${action.checklistItemId}`, a));

  if (category === CHECKLIST_TYPES.new_hire) {
    let newHireChecklist = cloneDeep(state.newHireChecklist);
    newHireChecklist = filter(newHireChecklist, (e) => !isEqual(e.id, checklistItemId));

    return { ...state, newHireChecklist, status };
  }
  if (category === CHECKLIST_TYPES.terminate) {
    let terminateChecklist = cloneDeep(state.terminateChecklist);
    terminateChecklist = filter(terminateChecklist, (e) => !isEqual(e.id, checklistItemId));

    return { ...state, terminateChecklist, status };
  }
  if (category === CHECKLIST_TYPES.start_shift) {
    let startShiftChecklist = cloneDeep(state.startShiftChecklist);
    startShiftChecklist = filter(startShiftChecklist, (e) => !isEqual(e.id, checklistItemId));

    return { ...state, startShiftChecklist, status };
  }
  if (category === CHECKLIST_TYPES.end_shift) {
    let endShiftChecklist = cloneDeep(state.endShiftChecklist);
    endShiftChecklist = filter(endShiftChecklist, (e) => !isEqual(e.id, action.checklistItemId));

    return { ...state, endShiftChecklist, status };
  }
  if (category === CHECKLIST_TYPES.activity_tracker) {
    let activityTrackerChecklist = cloneDeep(state.activityTrackerChecklist);
    activityTrackerChecklist = filter(activityTrackerChecklist, (e) => !isEqual(e.id, action.checklistItemId));

    return { ...state, activityTrackerChecklist, status };
  }
  let motionTrackerChecklist = cloneDeep(state.motionTrackerChecklist);
  motionTrackerChecklist = filter(motionTrackerChecklist, (e) => !isEqual(e.id, action.checklistItemId));

  return { ...state, motionTrackerChecklist, status };
};
const deleteChecklistItemFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-delete-checklist-item-${action.checklistItemId}`, a));

  return { ...state, status };
};

const submitUserNTChecklistRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-submit-user-nt-checklist');

  return {
    ...state,
    status,
  };
};
const submitUserNTChecklistSuccess = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-user-nt-checklist', a));

  return { ...state, successSubmitUserNTChecklist: true, status };
};
const submitUserNTChecklistFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-user-nt-checklist', a));

  return { ...state, status };
};

const fetchUserChecklistRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-submit-user-nt-checklist');

  return {
    ...state,
    status,
  };
};
const fetchUserChecklistSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-user-nt-checklist', a));

  return { ...state, userChecklist: action.response.userChecklist, status };
};
const fetchUserChecklistFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-user-nt-checklist', a));

  return { ...state, status };
};

const getUserNTChecklistRequest = (state, action) => {
  const status = cloneDeep(state.status);
  status.push(`pending-get-user-nt-checklist-${action.userId}`);

  return {
    ...state,
    status,
  };
};
const getUserNTChecklistSuccess = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-get-user-nt-checklist-${action.userId}`, a));

  return { ...state, userNTChecklist: action.response, status };
};
const getUserNTChecklistFailure = (state, action) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-get-user-nt-checklist-${action.userId}`, a));

  return { ...state, status };
};

const submitStartShiftChecklistRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-submit-shift-checklist');

  return { ...state, status };
};
const submitStartShiftChecklistSuccess = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-shift-checklist', a));

  return { ...state, successSubmitStartShiftChecklist: true, status };
};
const submitStartShiftChecklistFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-shift-checklist', a));

  return { ...state, status };
};

const submitEndShiftChecklistRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-submit-shift-checklist');

  return { ...state, status };
};
const submitEndShiftChecklistSuccess = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-shift-checklist', a));

  return {
    ...state,
    successSubmitEndShiftChecklist: true,
    status,
  };
};
const submitEndShiftChecklistFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-submit-shift-checklist', a));

  return { ...state, status };
};

const getUserShiftChecklistRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-user-shift-checklist');

  return { ...state, status };
};
const getUserShiftChecklistSuccess = (state, action) => {
  let userStartShiftChecklist = cloneDeep(state.userStartShiftChecklist);
  let userEndShiftChecklist = cloneDeep(state.userEndShiftChecklist);
  if (action.category === CHECKLIST_TYPES.start_shift) {
    userStartShiftChecklist = action.response;
  } else {
    userEndShiftChecklist = action.response;
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-user-shift-checklist', a));

  return {
    ...state,
    userStartShiftChecklist,
    userEndShiftChecklist,
    status,
  };
};
const getUserShiftChecklistFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-user-shift-checklist', a));

  return { ...state, status };
};

const clearSuccessSubmitUserNTChecklistRequest = (state) => ({
  ...state,
  successSubmitUserNTChecklist: null,
});
const clearSuccessSubmitStartShiftChecklistRequest = (state) => ({
  ...state,
  successSubmitStartShiftChecklist: null,
});

const clearSuccessSubmitEndShiftChecklistRequest = (state) => ({
  ...state,
  successSubmitEndShiftChecklist: null,
});

const clearChecklistRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [ChecklistTypes.GET_CHECKLIST_REQUEST]: getChecklistRequest,
  [ChecklistTypes.GET_CHECKLIST_SUCCESS]: getChecklistSuccess,
  [ChecklistTypes.GET_CHECKLIST_FAILURE]: getChecklistFailure,

  [ChecklistTypes.GET_CHECKLIST_BY_CATEGORY_REQUEST]: getChecklistByCategoryRequest,
  [ChecklistTypes.GET_CHECKLIST_BY_CATEGORY_SUCCESS]: getChecklistByCategorySuccess,
  [ChecklistTypes.GET_CHECKLIST_BY_CATEGORY_FAILURE]: getChecklistByCategoryFailure,

  [ChecklistTypes.CREATE_CHECKLIST_ITEM_REQUEST]: createChecklistItemRequest,
  [ChecklistTypes.CREATE_CHECKLIST_ITEM_SUCCESS]: createChecklistItemSuccess,
  [ChecklistTypes.CREATE_CHECKLIST_ITEM_FAILURE]: createChecklistItemFailure,

  [ChecklistTypes.CREATE_CHECKLIST_ITEMS_MULTIPLE_REQUEST]: createChecklistItemsMultipleRequest,
  [ChecklistTypes.CREATE_CHECKLIST_ITEMS_MULTIPLE_SUCCESS]: createChecklistItemsMultipleSuccess,
  [ChecklistTypes.CREATE_CHECKLIST_ITEMS_MULTIPLE_FAILURE]: createChecklistItemsMultipleFailure,

  [ChecklistTypes.EDIT_CHECKLIST_ITEM_REQUEST]: editChecklistItemRequest,
  [ChecklistTypes.EDIT_CHECKLIST_ITEM_SUCCESS]: editChecklistItemSuccess,
  [ChecklistTypes.EDIT_CHECKLIST_ITEM_FAILURE]: editChecklistItemFailure,

  [ChecklistTypes.DELETE_CHECKLIST_ITEM_REQUEST]: deleteChecklistItemRequest,
  [ChecklistTypes.DELETE_CHECKLIST_ITEM_SUCCESS]: deleteChecklistItemSuccess,
  [ChecklistTypes.DELETE_CHECKLIST_ITEM_FAILURE]: deleteChecklistItemFailure,

  [ChecklistTypes.SUBMIT_USER_NT_CHECKLIST_REQUEST]: submitUserNTChecklistRequest,
  [ChecklistTypes.SUBMIT_USER_NT_CHECKLIST_SUCCESS]: submitUserNTChecklistSuccess,
  [ChecklistTypes.SUBMIT_USER_NT_CHECKLIST_FAILURE]: submitUserNTChecklistFailure,

  [ChecklistTypes.FETCH_USER_CHECKLIST_REQUEST]: fetchUserChecklistRequest,
  [ChecklistTypes.FETCH_USER_CHECKLIST_SUCCESS]: fetchUserChecklistSuccess,
  [ChecklistTypes.FETCH_USER_CHECKLIST_FAILURE]: fetchUserChecklistFailure,

  [ChecklistTypes.GET_USER_NT_CHECKLIST_REQUEST]: getUserNTChecklistRequest,
  [ChecklistTypes.GET_USER_NT_CHECKLIST_SUCCESS]: getUserNTChecklistSuccess,
  [ChecklistTypes.GET_USER_NT_CHECKLIST_FAILURE]: getUserNTChecklistFailure,

  [ChecklistTypes.SUBMIT_START_SHIFT_CHECKLIST_REQUEST]: submitStartShiftChecklistRequest,
  [ChecklistTypes.SUBMIT_START_SHIFT_CHECKLIST_SUCCESS]: submitStartShiftChecklistSuccess,
  [ChecklistTypes.SUBMIT_START_SHIFT_CHECKLIST_FAILURE]: submitStartShiftChecklistFailure,

  [ChecklistTypes.SUBMIT_END_SHIFT_CHECKLIST_REQUEST]: submitEndShiftChecklistRequest,
  [ChecklistTypes.SUBMIT_END_SHIFT_CHECKLIST_SUCCESS]: submitEndShiftChecklistSuccess,
  [ChecklistTypes.SUBMIT_END_SHIFT_CHECKLIST_FAILURE]: submitEndShiftChecklistFailure,

  [ChecklistTypes.CLEAR_SUCCESS_SUBMIT_USER_NT_CHECKLIST_REQUEST]: clearSuccessSubmitUserNTChecklistRequest,
  [ChecklistTypes.CLEAR_SUCCESS_SUBMIT_START_SHIFT_CHECKLIST_REQUEST]:
    clearSuccessSubmitStartShiftChecklistRequest,
  [ChecklistTypes.CLEAR_SUCCESS_SUBMIT_END_SHIFT_CHECKLIST_REQUEST]: clearSuccessSubmitEndShiftChecklistRequest,

  [ChecklistTypes.GET_USER_SHIFT_CHECKLIST_REQUEST]: getUserShiftChecklistRequest,
  [ChecklistTypes.GET_USER_SHIFT_CHECKLIST_SUCCESS]: getUserShiftChecklistSuccess,
  [ChecklistTypes.GET_USER_SHIFT_CHECKLIST_FAILURE]: getUserShiftChecklistFailure,

  [ChecklistTypes.CLEAR_CHECKLIST_REQUEST]: clearChecklistRequest,
});
